export default {
  mobile: "320px",
  medium: "768px",
  desktop: "1024px",
};
